// Pixels to offset tooltip from cursor
const TOOLTIP_OFFSET = 10;

// Checks if a mouse is inside a rectangle
const isPointInRect = (point, rect) => {
  const { x, y } = point;
  return (
    x >= rect.x
    && x <= rect.x + rect.width
    && y >= rect.y
    && y <= rect.y + rect.height
  );
};

// Finds which gate is being hovered based on mouse
const findHoveredGate = (mouseX, mouseY, gates) => {
  for (const item of gates) {
    const { rect } = item.qubits;
    if (isPointInRect({ x: mouseX, y: mouseY }, rect)) {
      return { name: item.name, parametersList: item.parametersList };
    }
  }
  return null;
};

const calculateTooltipPosition = (event, tooltip, offset) => {
  // Initial position offset from mouse
  let tooltipX = event.clientX + offset;
  let tooltipY = event.clientY + offset;

  // Get viewport and tooltip dimensions
  const viewportWidth = document.documentElement.clientWidth;
  const viewportHeight = document.documentElement.clientHeight;
  const tooltipWidth = tooltip.offsetWidth;
  const tooltipHeight = tooltip.offsetHeight;

  // If tooltip overflow right edge, flip it to the left of cursor
  if (event.clientX + tooltipWidth + offset > viewportWidth) {
    tooltipX = event.clientX - tooltipWidth - offset;
  }

  // If tooltip overflow bottom edge, flip it above cursor
  if (event.clientY + tooltipHeight + offset > viewportHeight) {
    tooltipY = event.clientY - tooltipHeight - offset;
  }

  return { x: tooltipX, y: tooltipY };
};

export {
  TOOLTIP_OFFSET,
  findHoveredGate,
  calculateTooltipPosition,
};
